function fillWaitingPage(fullData) {
    var $page = $('#page');
    // First Check if waiting_flight_info is in the DOM
    if (!$('.waiting_flight_info')) {
        return;
    } else {
        // We have to create the logic here
        var depSegment = fullData.searchSegments[0];

        // Clear all hiddens and changes if any
        $('.waiting_dep')
            .css('margin-right', '');

        $('.waiting_depDate')
            .removeClass('od-ui-waiting-one-date-field');

        if (fullData.type === 'oneWayTrip' || fullData.type === 'roundTrip') {
            // If depCity.length + arrCity.length < 26, show City name. Otherwise, show IATA.
            var depCity = depSegment.departure.city;
            var destCity = depSegment.destination.city;
            var depName = depSegment.departure.name;
            var destName = depSegment.destination.name;
            var dest = depSegment.destination.iata;

            if (!Odigeo._.isEmpty(depCity) && !Odigeo._.isEmpty(destCity) &&
                depCity.length + destCity.length < 26) {
                $page.find('.waiting_dep').html(depCity);
                $page.find('.waiting_arr').html(destCity);
            } else if (!Odigeo._.isEmpty(depName) && !Odigeo._.isEmpty(destName) &&
                (depName.length + destName.length < 26) &&
                (depSegment.departure.type === 'CITY' && depSegment.destination.type === 'CITY')) {
                $page.find('.waiting_dep').html(depName);
                $page.find('.waiting_arr').html(destName);
            } else {
                $page.find('.waiting_dep').html(depSegment.departure.iata);
                $page.find('.waiting_arr').html(dest);
            }

            // If it is a RoundTrip fill both dates, if not, only fill departure and remove others
            var depDate;
            var arrDate;
            if (fullData.type === 'roundTrip') {
                depDate = Odigeo.Utils.parseDate(depSegment.dateStr);
                arrDate = Odigeo.Utils.parseDate(fullData.searchSegments[1].dateStr);
                $('.waiting_depDate').each(function(index, el) {
                    var $el = $(el);
                    $el.html(Odigeo.Utils.formatDate(depDate, $el.data('format'), true));
                });

                $('.waiting_arrDate').each(function(index, el) {
                    var $el = $(el);
                    $el.html(Odigeo.Utils.formatDate(arrDate, $el.data('format'), true));
                });
            } else { // It is a oneWay
                depDate = Odigeo.Utils.parseDate(depSegment.dateStr);
                $('.waiting_depDate').each(function(index, el) {
                    var $el = $(el);
                    $el.html(Odigeo.Utils.formatDate(depDate, $el.data('format'), true))
                        .addClass('od-ui-waiting-one-date-field')
                        .siblings()
                        .addClass('hidden');
                });
            }
        } else { // It is a MultiTrip
            $('.waiting_dep')
                .html(Odigeo.UIElements.translations.waitings.multipleCities)
                .css('margin-right', '20px')
                .siblings().addClass('hidden');

            $('.waiting_depDate')
                .html(Odigeo.UIElements.translations.waitings.multipleDates)
                .addClass('od-ui-waiting-one-date-field')
                .siblings().addClass('hidden');
        }

        // Add Number of travellers
        var nTraveller = parseInt(fullData.numAdults, 10) + parseInt(fullData.numChildren, 10) + parseInt(fullData.numInfants, 10);
        var $waitingTravellers = $('.waiting_travellers');
        var text = Odigeo.Utils.pluralizeAll($waitingTravellers.data('plurals'), nTraveller);

        $waitingTravellers.html(text);

        // animate companies
        var companiesList = $('.waiting_companies_list').text().split('|');
        var companiesIntervalInitialized = $('.waiting_companies_animation').attr('data-initialized');
        if (companiesList.length > 0 && companiesIntervalInitialized === 'false') {
            setInterval(function() {
                var rnd = Math.floor(Math.random() * (companiesList.length - 1));
                $('.waiting_companies_animation').text(companiesList[rnd]);
            }, 80);
            $('.waiting_companies_animation').attr('data-initialized', 'true');
        }

        // Fix font-size for header
        if (!Odigeo._.isEmpty(depSegment.departure.name) && !Odigeo._.isEmpty(depSegment.destination.name) &&
            (depSegment.departure.name.length > 20 || depSegment.destination.name.length > 20)) {
            $('.page-title').addClass('od-pagetitle-results-reduced-font');
        }
    }
}

module.exports = {
    fillWaitingPage: fillWaitingPage,
};
